var React = require('react');

function Send (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M27.45 15.11l-22-11a1 1 0 0 0-1.08.12a1 1 0 0 0-.33 1L6.69 15H18v2H6.69L4 26.74A1 1 0 0 0 5 28a1 1 0 0 0 .45-.11l22-11a1 1 0 0 0 0-1.78z","key":0}),React.createElement("rect",{"x":"0","y":"0","width":"32","height":"32","fill":"rgba(0, 0, 0, 0)","key":1})]);
}

Send.defaultProps = {"width":"32","height":"32","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 32 32","style":{"msTransform":"rotate(360deg)","WebkitTransform":"rotate(360deg)","transform":"rotate(360deg)"}};

module.exports = Send;

Send.default = Send;
